class LoginAndRecoverForm extends HTMLElement {
    constructor() {
        super();
        this.recoverFormTrigger = document.querySelector('.component--customer--login--form__recover-link');
        this.loginFormTrigger = document.querySelector('.component--customer--login--recover-form__login-link');
        this.recoverForm = document.querySelector('.component--customer--login--recover-form');
        this.loginForm = document.querySelector('.component--customer--login--form');
        this.checkUrlHash();
        this.bindEvents();
    }
    bindEvents() {
        this.recoverFormTrigger.addEventListener('click', this.showRecoverForm.bind(this));
    }
    checkUrlHash () {
        const hash = window.location.hash;
        if ( hash == '#recover' ) {
            this.showRecoverForm();
        }
    }
    showRecoverForm() {
        window.location.href = '/account/login#recover';
        this.recoverForm.classList.add( 'component--customer--login--recover-form--active' );
        this.loginForm.classList.remove( 'component--customer--login--form--active' );
    }
    showLoginForm() {
        window.location.href = '/account/login';
        this.recoverForm.classList.remove( 'component--customer--login--recover-form--active' );
        this.loginForm.classList.add( 'component--customer--login--form--active' );
    }
}
customElements.define('login-recover-form', LoginAndRecoverForm);